import { useEffect } from 'react';
import { X } from 'lucide-react';
import { cn, formatDate, bytesToHuman } from '../lib/utils.js';
import { useSnapImage } from '../hooks/useImage.js';

export default function Lightbox({ snap, onClose }) {
  const src = useSnapImage(snap?.id);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!snap) return null;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/80 p-4" onClick={onClose}>
      <button className="absolute right-3 top-3 btn-ghost" onClick={onClose} title="Close"><X size={16} /></button>
      <div className={cn('max-h-[90vh] max-w-[90vw] overflow-hidden rounded-2xl border border-border bg-panel shadow-2xl')} onClick={(e) => e.stopPropagation()}>
        {src
          ? <img src={src} alt={snap.filename} className="max-h-[80vh] max-w-[90vw] object-contain" />
          : <div className="grid h-64 w-96 place-items-center text-zinc-400">loading…</div>}
        <div className="flex items-center justify-between gap-3 border-t border-border/60 bg-zinc-900/60 px-3 py-2 text-xs text-zinc-300">
          <div className="truncate"><span className="font-medium text-zinc-100">{snap.filename}</span>{snap.caption ? ` — ${snap.caption}` : ''}</div>
          <div className="flex shrink-0 items-center gap-2 text-zinc-500">
            <span>{formatDate(snap.created_at)}</span>
            <span>·</span>
            <span>{bytesToHuman(snap.size_bytes)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
